import { h } from 'preact'
import { i18n } from 'i18n/i18n'

interface CalculatorErrorInfoProps {
  isBelowMinimalAmount: boolean
  isCurrentCurrencySupported: boolean
  minimalAmount: string
  minimalAmountCurrency: string
  customClassName?: string
}

export const CalculatorErrorInfo = ({
  isBelowMinimalAmount,
  isCurrentCurrencySupported,
  minimalAmount,
  minimalAmountCurrency,
  customClassName,
}: CalculatorErrorInfoProps) => {
  const baseClass = `exchange-calculator__error-info ${customClassName || ''}`.trim()

  if (!isCurrentCurrencySupported) {
    return <p className={baseClass}>{i18n('calculator.unsupportedPair')}</p>
  }

  if (isBelowMinimalAmount) {
    return (
      <p className={baseClass}>
        {i18n('calculator.minAmount', { amount: minimalAmount, currency: minimalAmountCurrency })}
      </p>
    )
  }
  return null
}
